import PointHistoryListTable from './pointHistoryListTable.container';

export default PointHistoryListTable